import BudgetedVsActualReportEditConfigController from './BudgetedVsActualReportEditConfigController'

export default class BudgetedVsActualResultConfigController extends BudgetedVsActualReportEditConfigController {}

BudgetedVsActualResultConfigController.prototype.makeReportParamsAccordingToFeatures = function(reportParameters) {
    return reportParameters
}


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/BudgetedVsActualResultConfigController.js